module.exports = __webpack_public_path__ + "img/nylon.be5030ca.webp";